<template>
  <router-link to='./'>
    <Responsive v-slot="{ breakpoint }">
      <h5  v-if="breakpoint === 'wide' && currentLanguage === 'fi'">Lakiasiaintoimisto</h5>
      <Logo />
      <h5  v-if="breakpoint === 'wide' && currentLanguage === 'en'">Legal</h5>
    </Responsive>
  </router-link>
</template>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()

  const currentLanguage = computed(() => {
    return route.params.language || 'en'
  })
</script>


<style scoped>

a {
  display: inline-block;
  white-space: nowrap;
  vertical-align: center;
}

h5 {
  display: inline-block;
  vertical-align: middle;
  height: 100%;
  margin-right: 1rem;
  margin-left: 1rem;
}

svg {
  height: 5.4rem;
}

</style>
